// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2sCKI","title":"ClientReferral_title__2G3y9","itemText":"ClientReferral_itemText__20omL"};